module.exports = __webpack_public_path__ + "images/banner-anhui.jpg?1565d41e506d2bde519765b34f0ce5e9";


//////////////////
// WEBPACK FOOTER
// ./src/images/active/banner-anhui.jpg
// module id = 169
// module chunks = 1